import { render, staticRenderFns } from "./GenericListItem.vue?vue&type=template&id=a1c3572a&"
import script from "./GenericListItem.vue?vue&type=script&lang=js&"
export * from "./GenericListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports